import React from "react"
import Footer from "./Footer"
import Header from "./Header"

class PrivacyPolicy extends React.Component {
  render() {
    return (
      <div>
        <Header />

        <div className="privacy-policy" style={{ marginBottom: "150px" }}>
          <h1>Privacy Policy</h1>
          <p>This website is maintained by:</p>
          <p>
            Garnet Education, 8 Southern Court, South Street, Reading, UK, RG1
            4QS
          </p>
          <p>
            We can be reached by e-mail at{" "}
            <a href="mailto:enquiries@garneteducation.com">
              enquiries@garneteducation.com
            </a>
            .
          </p>
          <p>
            <strong>Summary</strong>
            <br />
            We respect each of our users and their right to personal privacy. To
            that end, we collect and use information throughout this website in
            line with the terms and conditions outlined in this Privacy Policy.
            This statement applies solely to information collected on the
            English for Libya website and does not apply to sites accessed by
            outbound links.
          </p>
          <p>
            <strong>The Information You Provide</strong>
            <br />
            In order to access resources and the forum on this site we ask users
            to register some basic details. You can either register using an
            email address (which will need to be verified by clicking a link we
            send you) or you can login using your Facebook account. If you login
            using your Facebook account this site will only have access to your
            name, profile picture and email address. Any details collected
            during the registration process are held securely and only used to
            authenticate your access to the site and to link your profile to any
            public posts or comments you post in the forum area of the website.
            We will not use your name or e-mail address for any other purpose
            and will not sell or rent your name or address to parties not
            affiliated with Garnet Education.
          </p>
          <p>
            At other places in this site, we may ask for your feedback, opinion
            or suggestions, and provide you with a link for e-mailing us your
            response. If you send your e-mail to us, it will include your e-mail
            address in the “From” line. We promise to use the e-mail address we
            receive in this manner only for the purpose of responding to your
            questions or suggestions, and will not provide your e-mail address
            to anyone else.
          </p>
          <p>
            In order to understand how this site is used we use Google Analytics
            to collect data. This data is anonymised and is only used to
            understand broad usage trends so that we can improve the service.
          </p>
          <p>
            <strong>Data deletion</strong>
            <br />
            If you would like your data to be deleted we can remove your account
            and delete all public posts/comments. To request this please contact{" "}
            <a href="mailto:enquiries@garneteducation.com">
              enquiries@garneteducation.com
            </a>{" "}
            including ‘Data removal – English for Libya’ in the subject line of
            your email.
          </p>
        </div>

        <Footer />
      </div>
    )
  }
}

export default PrivacyPolicy



// WEBPACK FOOTER //
// ./src/components/PrivacyPolicy.js